import { __assign, __extends } from "tslib";
import React from 'react';
import { withDimensions } from '../../../../components/withDimensions';
import { getDefaultComponentData } from '../../types';
export default function galleryComponentWrapper(ExternalComponent) {
    return withDimensions(/** @class */ (function (_super) {
        __extends(GalleryComponentWrapper, _super);
        function GalleryComponentWrapper(props) {
            var _this = _super.call(this, props) || this;
            _this.stateFromProps = function (props) {
                var items = props.componentData.items || [];
                var styles = __assign(__assign({}, getDefaultComponentData()), (props.componentData.styles || {}));
                var state = {
                    items: items,
                    styles: styles,
                };
                return state;
            };
            _this.handleFilesAdded = function (data) {
                // when updating componentData on an async method like this one,
                // we need to use a sync method to change the EditorState.
                // The broadcast is good if the toolbar is displaying some status or images
                _this.props.componentData.data = data.data || data;
                _this.props.componentData.styles = _this.state.styles;
                var setData = _this.props.blockProps.setData;
                setData(_this.props.componentData);
                if (_this.props.store) {
                    _this.props.store.set('componentData', {
                        data: data.data || data,
                        styles: _this.state.styles,
                        config: _this.props.componentData.config,
                        settings: _this.props.settings,
                        items: [],
                    });
                }
            };
            _this.state = _this.stateFromProps(props);
            var _a = _this.props, block = _a.block, commonPubsub = _a.commonPubsub, store = _a.store;
            _this.blockKey = block === null || block === void 0 ? void 0 : block.getKey();
            commonPubsub &&
                commonPubsub.setBlockHandler('galleryHandleFilesAdded', _this.blockKey, _this.handleFilesAdded.bind(_this));
            if (store) {
                store.setBlockHandler('handleFilesAdded', _this.blockKey, _this.handleFilesAdded.bind(_this));
            }
            return _this;
        }
        GalleryComponentWrapper.prototype.render = function () {
            var _a, _b;
            var _c = this.props, _d = _c.componentData, data = _d.data, config = _d.config, styles = _d.styles, galleryLayout = _d.galleryLayout, settings = _d.settings, width = _c.width;
            // Some versions got layout mixed up but we have to support all options
            // now because old data is cached... styles should contain all the settings.
            var layout = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.galleryLayout) !== null && _a !== void 0 ? _a : galleryLayout) !== null && _b !== void 0 ? _b : settings === null || settings === void 0 ? void 0 : settings.defaultLayout;
            return (React.createElement(ExternalComponent, { config: config, data: data, layout: layout, width: width, settings: settings, layoutStyles: styles }));
        };
        return GalleryComponentWrapper;
    }(React.Component)));
}
//# sourceMappingURL=gallery-component-wrapper.js.map